import { createFileRoute } from "@tanstack/react-router"

// Import the existing campaign detail page
import CampaignDetail from "@/pages/jobs/campaigns/detail"

export const Route = createFileRoute("/_screen/campaign/affiliate/$id")({
  component: CampaignDetailPage
})

function CampaignDetailPage() {
  const { id } = Route.useParams()
  return <CampaignDetail id={id} />
}
